import { useState } from 'react';
import { KeyRound, Eye, EyeOff, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

export const AdminSetPassword = ({ api, userId, userName }) => {
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState('');
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (pw.length < 6) return toast.error('Password must be at least 6 characters');
    setSaving(true);
    try {
      await api().post(`/admin/users/${userId}/set-password`, { new_password: pw });
      toast.success(`Password updated for ${userName}. Share it with them privately.`);
      setPw(''); setOpen(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to set password');
    }
    setSaving(false);
  };

  if (!open) {
    return (
      <Button size="sm" variant="outline" onClick={() => setOpen(true)} className="mb-4 rounded-full border-primary/40 text-primary hover:bg-primary/10" data-testid="admin-set-password-open">
        <KeyRound className="h-4 w-4 mr-1.5" /> Set Password
      </Button>
    );
  }
  return (
    <div className="mb-4 rounded-2xl border border-primary/30 bg-primary/5 p-3" data-testid="admin-set-password-panel">
      <p className="text-xs text-white/70 mb-2">Set a new password for <b className="text-white">{userName}</b>. They'll be signed out everywhere and can log in with it right away.</p>
      <div className="flex gap-2">
        <div className="relative flex-1">
          <Input
            type={show ? 'text' : 'password'} value={pw} onChange={(e) => setPw(e.target.value)}
            placeholder="New password" className="h-10 bg-black border-border text-white pr-10 rounded-xl"
            data-testid="admin-set-password-input"
          />
          <button type="button" onClick={() => setShow((v) => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-white/50" aria-label="Show password" data-testid="admin-set-password-toggle">
            {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
          </button>
        </div>
        <Button onClick={save} disabled={saving} className="h-10 rounded-xl bg-primary text-black" data-testid="admin-set-password-save">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Save'}
        </Button>
        <Button variant="ghost" onClick={() => { setOpen(false); setPw(''); }} className="h-10 rounded-xl" data-testid="admin-set-password-cancel">Cancel</Button>
      </div>
    </div>
  );
};

export default AdminSetPassword;
